import { useLenis } from '@studio-freight/react-lenis'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export const useSmoothScroll = () => {
  let lenis = useLenis()

  const scrollTo = (fragment: string, offset = 0) => {
    const targetElement = document.getElementById(fragment.replace('#', ''))
    if (targetElement) {
      scroll(targetElement, offset)
    }
  }

  const scroll = (element: HTMLElement | null = null, offset = 0) => {
    gsap.to(window, {
      duration: Math.min(0.6 + Math.abs(window.scrollY - ((element?.offsetTop || 0) + offset)) * 0.0004, 1.8),
      scrollTo: element ? { y: element, offsetY: offset } : offset,
      ease: 'power2.inOut',
    })
  }

  const scrollToTop = () => {
    scroll()
  }

  const start = () => {
    if (lenis) {
      lenis.start()
    } else {
      // TODO: Lenisがない場合の処理を追加する
    }
  }

  const stop = () => {
    if (lenis) {
      lenis.stop()
    } else {
      // TODO: Lenisがない場合の処理を追加する
    }
  }

  return {
    lenis,
    start,
    stop,
    scrollTo,
    scrollToTop,
  }
}
